import React from "react";
import ReactDOM from "react-dom/client";
import { store, StoreContext } from "./store";
import { App, StyleProvider } from "./components";
import { queryClient } from "./utils/custom/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <QueryClientProvider client={queryClient}>
    <StyleProvider>
      <StoreContext.Provider value={store}>
        <App />
      </StoreContext.Provider>
    </StyleProvider>
  </QueryClientProvider>
);
